import { JoinConfirmation } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../mockHelper';
import LogCannon from '@ace-clublabs/log-cannon';
import CookieHelper from '../../utils/cookieHelper';
import { ITypedApiResponse } from '@lib/types';
import { JoinConfirmationData } from '../../application/models/JoinConfirmationData';

export const JoinConfirmationApi =
  (endpoint: string): JoinConfirmation =>
  async (request) => {
    const scenario = CookieHelper.getCookie('scenario');
    try {
      const constructedEndpoint = `${endpoint}/${request.sessionId}`;
      const response: ITypedApiResponse<JoinConfirmationData> = await axios.get(
        constructedEndpoint,
        createAxiosConfig(scenario, endpoint)
      );
      LogCannon.blast('Get JoinConfirmationApi success');
      return Promise.resolve(response.data);
    } catch (e) {
      return Promise.reject({ error: e });
    }
  };
